<div class="bg-white">
    <mat-card appearance="outlined">
        <div class="mainBody">
            <p style="font-weight: bold;">Nuevo Gasto</p>
            <hr/>
            <div class="row qr-hover" (click)="goQR()">
                <div class="col-md-6 text-center gasto-qr">
                  <mat-icon class="mat-icon-expense-selector-custom">crop_free</mat-icon>
                </div>

                <div class="col-md-6">
                    <span class="black-text">Escanear código QR</span>
                    <br />
                    <br />
                    <span class="justify-text">Escanear el código QR de sus facturas, para añadirlos directamente a sus
                        gastos.</span>
                </div>
            </div>

            <br />
            <br />

            <div class="row pencil-hover" (click)="goCreate()">
                <div class="col-md-6 text-center">
                  <mat-icon class="mat-icon-expense-selector-custom">create</mat-icon>
                </div>

                <div class="col-md-6">
                    <span class="black-text">Añadir factura manualmente</span>
                    <br />
                    <br />
                    <span class="justify-text">Si su factura no posee código QR puede proceder a introducir los datos
                        manualmente.</span>
                </div>
            </div>
        </div>
    </mat-card>
</div>
